import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { DeleteDocument } from 'app/store/documents/document.actions';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Document } from 'app/models/dto/document.model';

@Component({
    selector: 'app-document-delete-dialog',
    templateUrl: './document-delete-dialog.component.html',
    styleUrls: ['./document-delete-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DocumentDeleteDialogComponent {

    constructor(
        private store: Store,
        @Inject(MAT_DIALOG_DATA) public data: Document[],
        private dialogRef: MatDialogRef<DocumentDeleteDialogComponent>
    ) { }

    deleteDocuments() {
        this.data.forEach(document => {
            this.store.dispatch(new DeleteDocument(document.id)).pipe().subscribe();
        });
        this.dialogRef.close();
    }
}
